import { Buffer } from 'buffer';
import { ROBOT_TYPE_DATA, RobotConnectionStatus, RobotTypes } from './types';

export function getRobotImgFromType(robotType: RobotTypes | undefined) {
  if (robotType && ROBOT_TYPE_DATA[robotType]?.image) {
    return ROBOT_TYPE_DATA[robotType]?.image;
  }

  return {};
}

export function getRobotTypeDisplayName(robotType: RobotTypes | undefined) {
  if (robotType && ROBOT_TYPE_DATA[robotType]?.displayName) {
    return ROBOT_TYPE_DATA[robotType]?.displayName;
  }

  return '';
}

export function getRobotTypeFromId(typeId: number | undefined) {
  if (typeId === undefined) {
    return;
  }

  for (const type in ROBOT_TYPE_DATA) {
    const data = ROBOT_TYPE_DATA[type as RobotTypes];
    if (data?.id === typeId) {
      return type as RobotTypes;
    }
  }
}

export function decodeBleServiceData(
  serviceData: { [uuid: string]: string } | null
) {
  if (serviceData === null || Object.keys(serviceData).length === 0) {
    return null;
  }

  const primaryUuid = Object.keys(serviceData)[0];
  const buf = Buffer.from(serviceData[primaryUuid], 'base64');

  const robotTypeId = buf.readUInt8(0);
  const type = getRobotTypeFromId(robotTypeId);
  return {
    type,
    robotId: buf.readUInt32LE(1).toString(),
  };
}

export function compareRobotConnStatus(
  statusA: RobotConnectionStatus | undefined,
  statusB: RobotConnectionStatus | undefined,
  descending = false
) {
  const connectionStatuses: { [k in RobotConnectionStatus]: number } = {
    disconnected: 0,
    disconnecting: 1,
    connecting: 2,
    connected: 3,
  };
  const connStatusA = connectionStatuses[statusA ?? 'disconnected'] ?? 0;
  const connStatusB = connectionStatuses[statusB ?? 'disconnected'] ?? 0;

  return !descending ? connStatusA - connStatusB : connStatusB - connStatusA;
}
